import { intlFormatDistance, startOfDay } from "date-fns/esm";
import capitalize from "lodash-es/capitalize";

import { SearchSpaceliftVcsRepoCommitsItem } from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsRepoCommits/gql";
import { unixTimestampToMs } from "utils/time";

const getSpaceliftVcsRepoCommitsSectionLabel = (createdAt: number, now: Date) => {
  return capitalize(intlFormatDistance(startOfDay(createdAt), startOfDay(now), { unit: "day" }));
};

export const groupSpaceliftVcsRepoCommitsByDate = (
  commits: SearchSpaceliftVcsRepoCommitsItem[]
) => {
  const now = new Date();

  return commits.reduce<{ label: string; commits: SearchSpaceliftVcsRepoCommitsItem[] }[]>(
    (sections, commit) => {
      const sectionLabel = getSpaceliftVcsRepoCommitsSectionLabel(
        unixTimestampToMs(commit.createdAt),
        now
      );
      const lastSection = sections.at(-1);

      if (lastSection && lastSection.label === sectionLabel) {
        lastSection.commits.push(commit);
        return sections;
      }

      return [...sections, { label: sectionLabel, commits: [commit] }];
    },
    []
  );
};
